import { useEffect } from "react";

/**
 * On mount, scroll to the element named by the current URL hash.
 *
 * The landing app is a client-rendered SPA, so on a direct load of e.g.
 * `/resources/ask-anter#part-2` the target element does not exist when the
 * browser performs its native hash jump. This re-runs the jump after React
 * has rendered (next animation frame), so deep links land on the right section.
 * In-page TOC clicks keep using native anchor behavior.
 */
export function useHashScroll(): void {
  useEffect(() => {
    const id = window.location.hash.slice(1);
    if (!id) return;
    const raf = requestAnimationFrame(() => {
      document.getElementById(id)?.scrollIntoView();
    });
    return () => cancelAnimationFrame(raf);
  }, []);
}
